var _g, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChartIncreasing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_329_902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.14087,
    y: 4.09375,
    width: 55.8125,
    height: 55.8125,
    rx: 3.8,
    fill: "#FFFCF5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.14087,
    y: 4.09375,
    width: 55.8125,
    height: 55.8125,
    rx: 3.8,
    fill: "url(#paint0_linear_329_902)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.14087,
    y: 4.09375,
    width: 55.8125,
    height: 55.8125,
    rx: 3.8,
    fill: "url(#paint1_radial_329_902)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.14087,
    y: 4.09375,
    width: 55.8125,
    height: 55.8125,
    rx: 3.8,
    fill: "url(#paint2_radial_329_902)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.094 4.09375H21.094V20.875H4.14087V22.875H21.094V40.8125H4.14087V42.8125H21.094V59.9062H23.094V42.8125H41.094V59.9062H43.094V42.8125H59.9534V40.8125H43.094V22.875H59.9534V20.875H43.094V4.09375H41.094V20.875H23.094V4.09375ZM41.094 22.875V40.8125H23.094V22.875H41.094Z",
    fill: "url(#paint3_linear_329_902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.094 4.09375H21.094V20.875H4.14087V22.875H21.094V40.8125H4.14087V42.8125H21.094V59.9062H23.094V42.8125H41.094V59.9062H43.094V42.8125H59.9534V40.8125H43.094V22.875H59.9534V20.875H43.094V4.09375H41.094V20.875H23.094V4.09375ZM41.094 22.875V40.8125H23.094V22.875H41.094Z",
    fill: "url(#paint4_linear_329_902)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.094 4.09375H21.094V20.875H4.14087V22.875H21.094V40.8125H4.14087V42.8125H21.094V59.9062H23.094V42.8125H41.094V59.9062H43.094V42.8125H59.9534V40.8125H43.094V22.875H59.9534V20.875H43.094V4.09375H41.094V20.875H23.094V4.09375ZM41.094 22.875V40.8125H23.094V22.875H41.094Z",
    fill: "url(#paint5_linear_329_902)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.094 4.09375H21.094V20.875H4.14087V22.875H21.094V40.8125H4.14087V42.8125H21.094V59.9062H23.094V42.8125H41.094V59.9062H43.094V42.8125H59.9534V40.8125H43.094V22.875H59.9534V20.875H43.094V4.09375H41.094V20.875H23.094V4.09375ZM41.094 22.875V40.8125H23.094V22.875H41.094Z",
    fill: "url(#paint6_linear_329_902)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_329_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12597 53.9633C5.92628 53.3094 5.81885 52.6154 5.81885 51.8962V49.0107L18.9906 35.839C20.7783 34.0512 23.667 34.0199 25.4931 35.7684L29.0766 39.1997C29.4417 39.5493 30.0192 39.5432 30.3768 39.1859L57.4322 12.1562C57.615 12.7841 57.713 13.4481 57.713 14.1349V17.133L33.0054 41.817C31.2175 43.6033 28.3299 43.634 26.5044 41.886L22.9209 38.4547C22.5557 38.105 21.978 38.1113 21.6204 38.4688L6.12597 53.9633Z",
    fill: "#5B9D90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12597 53.9633C5.92628 53.3094 5.81885 52.6154 5.81885 51.8962V49.0107L18.9906 35.839C20.7783 34.0512 23.667 34.0199 25.4931 35.7684L29.0766 39.1997C29.4417 39.5493 30.0192 39.5432 30.3768 39.1859L57.4322 12.1562C57.615 12.7841 57.713 13.4481 57.713 14.1349V17.133L33.0054 41.817C31.2175 43.6033 28.3299 43.634 26.5044 41.886L22.9209 38.4547C22.5557 38.105 21.978 38.1113 21.6204 38.4688L6.12597 53.9633Z",
    fill: "url(#paint7_radial_329_902)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_329_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.47119 54.5294C4.25641 53.8262 4.14087 53.0797 4.14087 52.3063V49.2029L18.3071 35.0366C20.2299 33.1138 23.3367 33.0801 25.3007 34.9607L29.1548 38.6511C29.5474 39.0271 30.1685 39.0205 30.5532 38.6363L59.6514 9.56567C59.848 10.2409 59.9534 10.955 59.9534 11.6938V14.9182L33.3802 41.4661C31.4572 43.3872 28.3517 43.4202 26.3884 41.5402L22.5343 37.8498C22.1415 37.4737 21.5201 37.4805 21.1356 37.865L4.47119 54.5294Z",
    fill: "url(#paint8_linear_329_902)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_329_902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79297 49.5701L20.9954 35.2152C21.5713 34.6331 22.5076 34.6204 23.0991 35.1867L29.0691 40.9032C29.6574 41.4665 30.5877 41.4574 31.1649 40.8827L59.0805 13.0872",
    stroke: "url(#paint9_radial_329_902)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79297 49.5701L20.9954 35.2152C21.5713 34.6331 22.5076 34.6204 23.0991 35.1867L29.0691 40.9032C29.6574 41.4665 30.5877 41.4574 31.1649 40.8827L59.0805 13.0872",
    stroke: "url(#paint10_linear_329_902)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_329_902",
    x: 3.14087,
    y: 3.09375,
    width: 57.8125,
    height: 57.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.884314 0 0 0 0 0.87451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_329_902"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.74902 0 0 0 0 0.740863 0 0 0 0 0.698039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_329_902",
    result: "effect2_innerShadow_329_902"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729412 0 0 0 0 0.729412 0 0 0 0 0.729412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_329_902",
    result: "effect3_innerShadow_329_902"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_329_902",
    x: 4.81885,
    y: 11.1562,
    width: 53.894,
    height: 43.8071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_329_902"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_329_902",
    x: 4.14087,
    y: 9.56567,
    width: 56.0625,
    height: 45.2136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577708 0 0 0 0 0.983333 0 0 0 0 0.910585 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_329_902"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_329_902",
    x: 6.01523,
    y: 12.3099,
    width: 53.8416,
    height: 38.0359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3,
    result: "effect1_foregroundBlur_329_902"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_902",
    x1: 42.9974,
    y1: 60.4314,
    x2: 42.9974,
    y2: 55.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEBE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_329_902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.9534 32.7907) rotate(177.86) scale(11.185 43.6076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE7D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_329_902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2198 5.77663) rotate(138.434) scale(9.86402 10.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_329_902",
    x1: 32.0471,
    y1: 8.71875,
    x2: 32.0471,
    y2: 59.9063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEBE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_329_902",
    x1: 43.4848,
    y1: 61.3365,
    x2: 43.4848,
    y2: 54.3742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEBE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_329_902",
    x1: 2.20337,
    y1: 34.7187,
    x2: 12.8284,
    y2: 34.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3DBC1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_329_902",
    x1: 61.5784,
    y1: 36.0938,
    x2: 53.9534,
    y2: 36.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEBE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_329_902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7073 38.9526) rotate(71.9277) scale(6.037 7.4936)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57821,
    stopColor: "#32A691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814F7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_329_902",
    x1: 55.3284,
    y1: 26.8438,
    x2: 8.20337,
    y2: 46.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03E9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09C1A0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_329_902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.7054 37.3163) rotate(122.6) scale(14.2149 19.2471)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09C1A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_329_902",
    x1: 60.7515,
    y1: 13.0872,
    x2: 32.9368,
    y2: 42.9558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#149E86",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChartIncreasing);
export default __webpack_public_path__ + "static/media/ic_chart_increasing.f374f2757cad3279b333df634889e9c3.svg";
export { ForwardRef as ReactComponent };